(() => {
  const initialise = (root) => {
    if (root.dataset.journeysReady === 'true') return;
    root.dataset.journeysReady = 'true';

    const dialog = root.querySelector('[data-story-dialog]');
    const video = root.querySelector('[data-story-video]');
    const title = root.querySelector('[data-story-dialog-title]');
    const closeButton = root.querySelector('[data-story-close]');
    const triggers = root.querySelectorAll('[data-story-trigger]');
    const rail = root.querySelector('[data-carousel-rail]');
    const cards = Array.from(root.querySelectorAll('[data-carousel-card]'));
    const previousButton = root.querySelector('[data-carousel-previous]');
    const nextButton = root.querySelector('[data-carousel-next]');
    const dots = Array.from(root.querySelectorAll('[data-carousel-dot]'));
    const status = root.querySelector('[data-carousel-status]');
    if (
      !dialog || !video || !title || !closeButton || !triggers.length ||
      !rail || !cards.length || !previousButton || !nextButton ||
      dots.length !== cards.length || !status
    ) return;

    let lastTrigger = null;
    let savedScrollY = 0;
    let savedOverflow = '';
    let activeIndex = 0;
    let scrollTimer = 0;
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const updateCarousel = (index) => {
      activeIndex = Math.max(0, Math.min(index, cards.length - 1));
      previousButton.disabled = activeIndex === 0;
      nextButton.disabled = activeIndex === cards.length - 1;
      status.textContent = `${activeIndex + 1} of ${cards.length}`;
      dots.forEach((dot, dotIndex) => {
        dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false');
      });
    };

    const cardScrollLeft = (index) => cards[index].offsetLeft - cards[0].offsetLeft;

    const scrollToCard = (index, behavior = 'smooth') => {
      const nextIndex = Math.max(0, Math.min(index, cards.length - 1));
      updateCarousel(nextIndex);
      rail.scrollTo({
        left: cardScrollLeft(nextIndex),
        behavior: reducedMotionQuery.matches ? 'auto' : behavior,
      });
    };

    const syncFromScroll = () => {
      if (!mobileQuery.matches) return;
      const nearest = cards.reduce((bestIndex, card, index) => {
        const distance = Math.abs(cardScrollLeft(index) - rail.scrollLeft);
        const bestDistance = Math.abs(cardScrollLeft(bestIndex) - rail.scrollLeft);
        return distance < bestDistance ? index : bestIndex;
      }, 0);
      updateCarousel(nearest);
    };

    previousButton.addEventListener('click', () => scrollToCard(activeIndex - 1));
    nextButton.addEventListener('click', () => scrollToCard(activeIndex + 1));
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        scrollToCard(Number(dot.dataset.carouselIndex || 0));
      });
    });
    rail.addEventListener('scrollend', syncFromScroll);
    rail.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(syncFromScroll, 90);
    }, { passive: true });
    rail.addEventListener('keydown', (event) => {
      if (!mobileQuery.matches) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        scrollToCard(activeIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        scrollToCard(activeIndex + 1);
      }
    });
    window.addEventListener('resize', () => {
      if (mobileQuery.matches) scrollToCard(activeIndex, 'auto');
    }, { passive: true });
    updateCarousel(0);

    const unload = () => {
      video.pause();
      video.removeAttribute('src');
      video.removeAttribute('poster');
      video.load();
    };

    const restorePage = () => {
      unload();
      document.documentElement.style.overflow = savedOverflow;
      window.scrollTo(0, savedScrollY);
      window.requestAnimationFrame(() => {
        window.scrollTo(0, savedScrollY);
        if (lastTrigger) lastTrigger.focus({ preventScroll: true });
      });
    };

    const closeDialog = () => {
      if (dialog.open) dialog.close();
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const source = trigger.dataset.videoSrc;
        const poster = trigger.dataset.videoPoster;
        const videoTitle = trigger.dataset.videoTitle;
        if (!source || !poster || !videoTitle) return;
        lastTrigger = trigger;
        savedScrollY = window.scrollY;
        savedOverflow = document.documentElement.style.overflow;
        title.textContent = videoTitle;
        video.setAttribute('aria-label', videoTitle);
        video.poster = poster;
        video.src = source;
        video.load();
        document.documentElement.style.overflow = 'hidden';
        dialog.showModal();
        closeButton.focus({ preventScroll: true });
        const playback = video.play();
        if (playback && typeof playback.catch === 'function') playback.catch(() => {});
      });
    });

    closeButton.addEventListener('click', closeDialog);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('close', restorePage);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && dialog.open) {
        event.preventDefault();
        closeDialog();
      }
    });
  };

  const start = () => {
    document.querySelectorAll('[data-stria-customer-journeys]').forEach(initialise);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
